<div class="eui-page-column__header"
    [class.eui-page-column__header--with-icons]="isCollapsedWithIcons">

    <div *ngIf="!customHeaderLeftContent" class="eui-page-column__header-left-content">
        <div *ngIf="label" class="eui-page-column__header-left-content-label">
            <ng-content *ngIf="customHeaderCollapsedContent" select="eui-page-column-header-collapsed-content"></ng-content>
            <ng-container *ngIf="!isCollapsedWithIcons">
                {{label}}
            </ng-container>
        </div>
    </div>
    <div *ngIf="customHeaderLeftContent" class="eui-page-column__header-left-content">
        <ng-content select="eui-page-column-header-left-content"></ng-content>
    </div>

    <div class="eui-page-column__header-right-content">
        <span *ngIf="customHeaderRightContent" class="eui-page-column__header-right-content-body">
            <ng-content select="eui-page-column-header-right-content"></ng-content>
        </span>
        <button *ngIf="isCollapsible"
                euiButton euiBasicButton euiSecondary euiRounded euiIconButton euiSizeS
                (click)="onToggle()"
                [attr.aria-label] = "isCollapsed? 'Expand': 'Collapse'"
                class="eui-page-column__header-toggle eui-icon"
                [class.eui-icon-angle-right]="isCollapsed && !(asService.state$ | async).breakpoints.isMobile"
                [class.eui-icon-angle-left]="!isCollapsed && !(asService.state$ | async).breakpoints.isMobile"
                [class.eui-icon-angle-down]="isCollapsed && (asService.state$ | async).breakpoints.isMobile"
                [class.eui-icon-angle-up]="!isCollapsed && (asService.state$ | async).breakpoints.isMobile">
        </button>
    </div>
</div>
<!-- On new line to not interfere with expand/collapse & custom right content -->
<div *ngIf="customHeaderBodyContent"
     class="eui-page-column__header-left-content-body"
     [class.eui-page-column__header-left-content-body--shrinked]="isHeaderBodyShrinked">
    <ng-content select="eui-page-column-header-body"></ng-content>
</div>
<div class="eui-page-column__body"
    tabindex="0"
    [class.eui-page-column__body--interactive-scrollbars]="interactiveScrollbars"
    [class.eui-page-column--collapsed-with-icons]="isCollapsedWithIcons"
    (mouseenter) ="onMouseEnter()"
    (mouseleave) ="onMouseLeave()"
    (scroll)="hasHeaderBodyShrinkable ? onBodyScoll($event) : null">
    <ng-content select="eui-page-column-body"></ng-content>
</div>
<div *ngIf="customFooterContent" class="eui-page-column__footer" [class.eui-page-column__footer--highlighted]="isHighlighted">
    <ng-content select="eui-page-column-footer"></ng-content>
</div>
